import { withClickTracking } from '@modernhealth/web-analytics';
import { Button as VitaButton } from '@modernhealth/vital-components';

import { InternalLink as SourceInternalLink } from 'src/shared/components/InternalLink';
import { InternalLinkButton as SourceInternalLinkButton } from 'src/shared/components/InternalLinkButton';
import { ExternalLinkButton as SourceExternalLinkButton } from 'src/shared/components/ExternalLinkButton';

export const Button = withClickTracking(VitaButton);
export const InternalLink = withClickTracking(SourceInternalLink);
export const InternalLinkButton = withClickTracking(SourceInternalLinkButton);
export const ExternalLinkButton = withClickTracking(SourceExternalLinkButton);
